import React from 'react';
import './MandalaCard.css';
import { ROOT_IMG_URL } from '../../GlobalValues';

const MandalaCard = ({ title, children, style = {} }) => {
  const background = `${ROOT_IMG_URL}/mandalanoir.jpg`;
  return (
    <section className="promotion-container" style={{ ...style }}>
      {/* LCP background image — use an actual <img> for better preload/size semantics */}
      <picture>
        <source type="image/jpg" />
        <img
          className="promotion-bg"
          src={background}
          alt={title || 'Illustration'}
          width={880}
          height={880}
          loading="eager"
          fetchpriority="high"
        />
      </picture>
      <div className="sl-container">
        <div className="sl-flex sl-flex-col sl-ai-center sl-jc-center sl-gap-l">
          <h3 className="sl-title-bloc-reverse sl-title">{title}</h3>
          {children}
        </div>
      </div>
    </section>
  );
};

export default MandalaCard;
